export const convertDataToTimezonedData = (data: object[], formatter: (date: string) => string) => {
  return data.map((item) => {
    if ('day' in item && typeof item.day === 'string') {
      return {
        ...item,
        day: formatter(item.day),
      }
    }

    return item
  })
}
